/**
 * Referral code cookie utilities.
 * Frontend-managed cookie (not httpOnly) for /invite/:code flow.
 * Does not replace or modify existing sessionStorage referral logic.
 */

const COOKIE_NAME = 'referral_code'
const MAX_AGE_SECONDS = 604800 // 7 days

function getCookieString(code: string): string {
  const parts = [
    `${encodeURIComponent(COOKIE_NAME)}=${encodeURIComponent(code)}`,
    `max-age=${MAX_AGE_SECONDS}`,
    'path=/',
    'secure',
    'samesite=lax',
  ]
  return parts.join('; ')
}

/**
 * Set referral code in a cookie (frontend-managed, 7 days).
 */
export function setReferralCookie(code: string): void {
  if (typeof document === 'undefined') return
  document.cookie = getCookieString(code)
}

/**
 * Read referral code from cookie.
 */
export function getReferralCookie(): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`)
  )
  if (!match) return null
  try {
    return decodeURIComponent(match[1].trim())
  } catch {
    return null
  }
}

/**
 * Clear the referral code cookie.
 */
export function clearReferralCookie(): void {
  if (typeof document === 'undefined') return
  document.cookie = `${encodeURIComponent(COOKIE_NAME)}=; max-age=0; path=/; secure; samesite=lax`
}
